/**
 * Created by seaasun on 2017/12/12.
 * This page is copy and edit from old version scripts/helper/helper.order.js
 */

import store from '@/store/index'
// copy form old sl360 Scripts/entity/entity.enums.js
const enums = {
  PromotionMinPurAmtType: {
    BY_TOTAL_SPEND: 1,
    BY_TOTAL_RECORDS: 2,
    BY_TOTAL_SPEND_RECORDS: 3
  },
  PromotionType: {
    PERCENT_OFF_TOTAL_PRICE: 1,
    FREE_LEADS: 2,
    FLAT_DOLLAR_TOTAL_PRICE: 3,
    XNUMBER_OF_POINT: 4,
    NUMBER_OF_POINT: 5,
    DEBIT_CARD: 6,
    DOLLAR_MOBILE_ONLY: 7,
    DOLLAR_MOBILE_LIST_BOTH: 8,
    PERCENT_OFF_MOBILE_ONLY: 9,
    PERCENT_OFF_MOBILE_LIST_BOTH: 10
  },
  ListUsageType: {
    OneTimes: 1,
    TwoTimes: 2,
    ThreeTimes: 2,
    FourTimes: 4,
    FiveTimes: 5,
    SixTimes: 6,
    MultiTimes: 100
  },
  CalculatePriceMethod: {
    WholeOrder: 0,
    OnlyBase: 1
  }
}

/* eslint-disable no-unused-vars */
function RecaculateTotalQty (order) {
  if (order.OrderGeos.length > 0) {
    order.DesiredQtyHome = 0
    order.DesiredQtyApt = 0
    order.DesiredQtyBuss = 0
    order.AvailableQtyHome = 0
    order.AvailableQtyApt = 0
    order.AvailableQtyBuss = 0
    order.TotalDesiredQty = 0
    order.TotalAvailableQty = 0
    order.TotalEmailDesiredQty = 0
    for (let value of order.OrderGeos) {
      order.DesiredQtyHome += value.DesiredQtyHome
      order.DesiredQtyApt += value.DesiredQtyApt
      order.DesiredQtyBuss += value.DesiredQtyBuss
      order.AvailableQtyHome += value.AvailableQtyHome
      order.AvailableQtyApt += value.AvailableQtyApt
      order.AvailableQtyBuss += value.AvailableQtyBuss
      order.TotalDesiredQty += value.DesiredQty
      order.TotalAvailableQty += value.AvailableQty
      order.TotalEmailDesiredQty += value.EmailDesiredQty
    }
    // order.TotalDesiredQty = order.DesiredQtyHome + order.DesiredQtyApt + order.DesiredQtyBuss;
    // order.TotalAvailableQty = order.AvailableQtyHome + order.AvailableQtyApt + order.AvailableQtyBuss;
  }
}

/* eslint-disable no-unused-vars */
function RecaculateTotalGeoQtyAll (order) {
  for (var i = 0; i < order.OrderGeos.length; i++) {
    var geo = order.OrderGeos[i]
    geo.DesiredQtyHome = 0
    geo.DesiredQtyApt = 0
    geo.DesiredQtyBuss = 0
    geo.AvailableQtyHome = 0
    geo.AvailableQtyApt = 0
    geo.AvailableQtyBuss = 0
    for (let value of order.OrderGeos[i].OrderGeoDetails) {
      geo.DesiredQtyHome += value.DesiredQtyHome
      geo.DesiredQtyApt += value.DesiredQtyApt
      geo.DesiredQtyBuss += value.DesiredQtyBuss
      geo.AvailableQtyHome += value.AvailableQtyHome
      geo.AvailableQtyApt += value.AvailableQtyApt
      geo.AvailableQtyBuss += value.AvailableQtyBuss
    }
    geo.DesiredQty = geo.DesiredQtyHome + geo.DesiredQtyApt + geo.DesiredQtyBuss
    geo.AvailableQty = geo.AvailableQtyHome + geo.AvailableQtyApt + geo.AvailableQtyBuss
  }
}

/* eslint-disable no-unused-vars */
function RecaculateTotalGeoQty (order, geoIndex) {
  var geo = order.OrderGeos[geoIndex]
  geo.DesiredQtyHome = 0
  geo.DesiredQtyApt = 0
  geo.DesiredQtyBuss = 0
  geo.AvailableQtyHome = 0
  geo.AvailableQtyApt = 0
  geo.AvailableQtyBuss = 0
  geo.DesiredQty = 0
  geo.AvailableQty = 0
  geo.EmailDesiredQty = 0
  geo.EmailAvailableQty = 0
  for (let value of order.OrderGeos[geoIndex].OrderGeoDetails) {
    if (order.ListType === 50) {
      geo.DesiredQtyHome += value.DesiredQtyHome
      geo.DesiredQtyApt += value.DesiredQtyApt
      geo.DesiredQtyBuss += value.DesiredQtyBuss
      geo.AvailableQtyHome += value.AvailableQtyHome
      geo.AvailableQtyApt += value.AvailableQtyApt
      geo.AvailableQtyBuss += value.AvailableQtyBuss
    } else {
      geo.DesiredQty += value.DesiredQty
      geo.AvailableQty += value.AvailableQty
      geo.EmailDesiredQty = value.Email_DesiredQty
      geo.EmailAvailableQty = value.Email_AvailableQty
    }
  }

  if (order.ListType === 50) {
    geo.DesiredQty = geo.DesiredQtyHome + geo.DesiredQtyApt + geo.DesiredQtyBuss
    geo.AvailableQty = geo.AvailableQtyHome + geo.AvailableQtyApt + geo.AvailableQtyBuss
  }
  RecaculateTotalQty(order)
}

function GetMobilePackagePromotionValue (promotionCode, mobilePackageId) {
  let value = 0
  if (promotionCode === null || promotionCode.Length === 0) {
    return 0
  }
  let promotion = store.state.summary.Promotion
  let mobilePackages = store.state.summary.MobilePackages
  if (promotion != null) {
    if (CheckMobileCondition(mobilePackageId, promotion.PackageIds)) {
      var prom = 0
      var pack = mobilePackages.getPackageById(mobilePackageId)
      if (promotion === 7) { // 7: entity.enums.PromotionType.DOLLAR_MOBILE_ONLY
        prom = promotion.PromotionValue
      } else if (promotion.PromotionType === 7) { // 7: entity.enums.PromotionType.DOLLAR_MOBILE_ONLY
        prom = pack.Cost * promotion.PromotionValue
      }
    }
    var totalValue = pack.Cost - prom
    if (totalValue < promotion.MinPurAmount) {
      value = promotion.MinPurAmount - pack.Cost
    } else {
      value = 0 - prom
    }
  }
  return value
}

function CaculateMobilePromotion (order, promotion) {
  let mobilePackages = store.state.summary.MobilePackages
  if (CheckPromotCode(order)) {
    if (promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_ONLY || promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_LIST_BOTH ||
      promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_ONLY || promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_LIST_BOTH) {
      if (order.MobilePackageId > 0) {
        var pack = mobilePackages.getPackageById(order.MobilePackageId)
        if (CheckMobileCondition(order.MobilePackageId, promotion.PackageIds)) {
          order.MobilePackageCharge = pack.Cost - promotion.PromotionValue
          var mobileCharge = 0
          if (promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_ONLY || promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_LIST_BOTH) {
            mobileCharge = pack.Cost - promotion.PromotionValue
          } else if (promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_ONLY || promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_LIST_BOTH) {
            mobileCharge = pack.Cost - pack.Cost * promotion.PromotionValue
          }
          if (mobileCharge < promotion.MinPurAmount) {
            mobileCharge = promotion.MinPurAmount
          }
          order.MobilePackageCharge = mobileCharge
        } else {
          order.MobilePackageCharge = pack.Cost
        }
      }
    }
  }
  return order
}
function CaculateMobilePackageCharge (order, promotion) {
  let mobilePackages = store.state.summary.MobilePackages
  if (CheckPromotCode(order) === false) {
    if (order.MobilePackageId > 0) {
      var pack = mobilePackages.getPackageById(order.MobilePackageId)
      order.MobilePackageCharge = pack.Cost
    }
  } else {
    CaculateMobilePromotion(order, promotion)
  }
}

function CheckPromotCode (order) {
  var PCode = order.PromoCode
  if (PCode == null || PCode.Length === 0) {
    return false
  } else {
    return true
  }
}

function CaculatePromotion (order, plUser, promotion) {
  order.PromotionAmount = GetPromotionCharge(order, promotion)
  CaculateMobilePackageCharge(order, promotion)
  var cost = null
  if (promotion && promotion.PromotionType === enums.PromotionType.DEBIT_CARD && order.PromotionAmount > 0) {
    var total = order.OrderCharge + order.ShippingCharge + order.LabelCharge + order.ServiceCharge + order.GeographyCharge
    if (total > order.PromotionAmount) {
      order.TotalEstmCost = total - order.PromotionAmount
    } else {
      order.PromotionAmount = total
      order.TotalEstmCost = 0
    }
  } else {
    // get sub total charge
    var subTotalCharge = order.OrderCharge - order.PromotionAmount
    if (promotion) {
      if (promotion.IsNoRequired) {
      } else {
        if (order.OrderCharge <= plUser.MinElementsCharge) {
          subTotalCharge = plUser.MinElementsCharge
          order.PromotionAmount = 0
        } else if (order.OrderCharge > plUser.MinElementsCharge) {
          cost = order.OrderCharge - plUser.MinElementsCharge
          if (cost <= order.PromotionAmount) {
            order.OrderCharge = plUser.MinElementsCharge
            order.PromotionAmount = cost
          } else {
            order.OrderCharge = subTotalCharge
          }
        }
      }
    } else {
      if (subTotalCharge < plUser.MinElementsCharge) {
        subTotalCharge = plUser.MinElementsCharge
      }
    }
    order.SubTotalCharge = subTotalCharge
    order.TotalEstmCost = order.SubTotalCharge + order.ShippingCharge + order.LabelCharge + order.ServiceCharge + order.GeographyCharge
    order.MinElementsChargeApply = (order.SubTotalCharge === plUser.MinElementsCharge)
  }
  order.TotalPretaxCost = order.TotalEstmCost
  return order
}

function GetMultiplePriceByListUsageType (listUsageType, mprice) {
  for (var i = 0; i < mprice.length; i++) {
    if (mprice[i].MultipleId === listUsageType) {
      return mprice[i].Multiple
    }
  }
}

function GetSinglePrice (order, plUser, plGlobal) {
  var qty = order.TotalDesiredQty
  var listUsage = order.ListUsage
  var mprice = plUser === null ? plGlobal.ListMultiplePrice : plUser.ListMultiplePrice
  var multiplePrice = GetMultiplePriceByListUsageType(listUsage, mprice)
  var myCalculatePriceMethod = store.state.summary.CalculatePriceMethod
  // caculate demo elements pricing
  var singleprice = 0
  var singlepriceSubItmes = 0
  for (var i = 0; i < order.ElementsForPricing.length; i++) {
    var el = order.ElementsForPricing[i]
    // add by erik wang @20210708
    // if order geo type is multi count, we must make sure geo desired qty >0 then add that price element
    if (el.IsMultiCountElement === true) {
      var geoCountIds = el.MultiCountIds.split(',')
      var existed = false
      for (var c = 0; c < geoCountIds.length; c++) {
        for (var j = 0; j < order.OrderGeos.length; j++) {
          if (geoCountIds[c] === order.OrderGeos[j].GeoKeyCode) {
            if (order.OrderGeos[j].DesiredQty > 0) {
              existed = true
            }
          }
        }
      }
      if (existed === false) {
        continue
      }
    }

    if (el.ValuesCount < 1) {
      el.ValuesCount = 1
    }
    // get from user price list first
    var p = GetPriceByElement(el.ElementName, qty, plUser)
    var valuePrice = null
    if (p === null) {
      p = GetPriceByElement(el.ElementName, qty, plGlobal)
      el.Price = (p === null ? plGlobal.GlobalElementPrice : p.Price1)
      el.IsGlobal = true
      el.NotificationRequired = p === null ? true : p.NotificationRequired
      el.PriceListName = p === null ? 'default' : plGlobal.PriceListName

      valuePrice = p === null ? 0 : p.Price2
      valuePrice = (el.ValuesCount - 1) * valuePrice
      el.Price = el.Price + valuePrice
      singlepriceSubItmes += el.Price

      if (listUsage > enums.ListUsageType.OneTimes && el.IsMultiple) {
        //  el.Price = el.Price * plGlobal.MultiplePrice;
        if (myCalculatePriceMethod === enums.CalculatePriceMethod.WholeOrder) {
          el.Price = el.Price * multiplePrice
        } else {
          if (el.ElementName.toUpperCase() === 'BASE') {
            el.Price = el.Price * multiplePrice
          }
        }
      }
    } else {
      el.Price = p.Price1
      el.IsGlobal = false
      el.PriceListName = plUser.PriceListName
      valuePrice = p === null ? 0 : p.Price2
      valuePrice = (el.ValuesCount - 1) * valuePrice
      el.Price = el.Price + valuePrice
      singlepriceSubItmes += el.Price

      // var multiplePrice = plUser === null ? plGlobal.MultiplePrice : plUser.MultiplePrice;
      // var mprice = plUser === null ? plGlobal.ListMultiplePrice : plUser.ListMultiplePrice;
      if (listUsage > enums.ListUsageType.OneTimes && el.IsMultiple) {
        // el.Price = el.Price * multiplePrice;
        if (myCalculatePriceMethod === enums.CalculatePriceMethod.WholeOrder) {
          el.Price = el.Price * multiplePrice
        } else {
          if (el.ElementName.toUpperCase() === 'BASE') {
            el.Price = el.Price * multiplePrice
          }
        }
      }
    }
    singleprice += el.Price
  }
  return singleprice
}

function GetSingleGoodsPrice (order, metadataPriceList) {
  var singleprice = 0
  var myCalculatePriceMethod = store.state.summary.CalculatePriceMethod
  if (metadataPriceList !== undefined && metadataPriceList != null) {
    var qty = order.TotalDesiredQty
    var listUsage = order.ListUsage
    // caculate demo elements pricing

    var maxBasePrice = 0
    var maxMapMultiuseFactor = 0
    var mprice = store.state.summary.UserPriceList === null ? store.state.summary.GlobalPriceList.ListMultiplePrice : store.state.summary.UserPriceList.ListMultiplePrice
    maxMapMultiuseFactor = GetMultiplePriceByListUsageType(listUsage, mprice)
    for (var i = 0; i < order.ElementsForPricing.length; i++) {
      var el = order.ElementsForPricing[i]
      if (el.ValuesCount < 1) {
        el.ValuesCount = 1
      }
      // get from user price list first
      var p = GetGoodsPriceByElement(el.ElementName, metadataPriceList)

      // if (p === null && el.ElementName === "BASE") {
      if (p === null && PriceElementEquals(el.ElementName.toUpperCase(), 'BASE')) {
        maxBasePrice = metadataPriceList.MapBasePrice
      } else {
        if (p != null) {
          el.Price = (p.MapColumnPrice === null ? 0 : p.MapColumnPrice)
          el.IsGlobal = false
          var valuePrice = p === null ? 0 : (p.MapColumnPrice2 === null ? 0 : p.MapColumnPrice2)
          valuePrice = (el.ValuesCount - 1) * valuePrice
          el.Price = el.Price + valuePrice
          singleprice += el.Price
        }
      }
    }

    // singleprice = maxBasePrice + singleprice;
    if (listUsage > enums.ListUsageType.OneTimes && el.IsMultiple) {
      if (myCalculatePriceMethod === enums.CalculatePriceMethod.WholeOrder) {
        singleprice = (singleprice + maxBasePrice) * maxMapMultiuseFactor
      } else {
        singleprice = maxBasePrice * maxMapMultiuseFactor + singleprice
      }
    } else {
      singleprice = maxBasePrice + singleprice
    }

    let maxCostOfGoodPrice = store.state.summary.MaxCostOfGoodPrice
    if (maxCostOfGoodPrice > 0 && singleprice > maxCostOfGoodPrice) {
      singleprice = maxCostOfGoodPrice
    }
  }
  return singleprice
}

function GetPriceByElement (element, qty, pricelist) {
  for (var i = 0; i < pricelist.ElementsPrices.length; i++) {
    var priceObj = pricelist.ElementsPrices[i]
    if (PriceElementEquals(priceObj.PriceName, element) && priceObj.Lbound <= qty && priceObj.Ubound >= qty) {
      return priceObj
    }
  }
  return null
}

function GetGoodsPriceByElement (element, metadataPricelist) {
  if (metadataPricelist !== undefined && metadataPricelist != null && metadataPricelist.MetadataPricingList !== undefined && metadataPricelist.MetadataPricingList !== null) {
    for (var i = 0; i < metadataPricelist.MetadataPricingList.length; i++) {
      var priceObj = metadataPricelist.MetadataPricingList[i]
      if (PriceElementEquals(priceObj.ColumnName, element)) {
        return priceObj
      }
    }
  }
  return null
}

/// <summary>
/// Get label charge by follow steps:
/// 1 find price object by price name : base
/// 2 calculate label charge
/// 2.1 baseprice * qty < min price, return min price
/// 2.2 else return baseprice * qty
/// </summary>
/// <param name="order">order</param>
/// <param name="pl">qlabel price list</param>
function GetLabelBaseCharge (order, pricelist) {
  var qty = order.TotalDesiredQty
  var labels = order.MailLabelsCount
  if (labels === 0) {
    return 0
  }

  var elPrice = 0
  for (var i = 0; i < pricelist.LabelPrices.length; i++) {
    var priceObj = pricelist.LabelPrices[i]
    if (PriceElementEquals(priceObj.PriceName, 'base') && priceObj.Lbound <= qty && priceObj.Ubound >= qty) {
      elPrice = priceObj.Price1
      break
    }
  }

  // get base label charge
  var baseCharge = elPrice * qty * labels
  if (baseCharge < pricelist.MinLabelCharge) {
    baseCharge = pricelist.MinLabelCharge
  }
  return baseCharge
}
/// <summary>
/// Get Shipping charge by follow steps:
/// 1 find price object by price name : shipprice
/// 2 calculate shipping charge
/// 2.1 the first labels' price is price1
/// 2.2 the follow labels' price is price2
/// 2.3 total shipping charge = 1*price1 + (labels-1)*price2
/// </summary>
/// <param name="order">order</param>
/// <param name="pl">qlabel price list</param>
function GetLabelShipCharge (order, pricelist) {
  var qty = order.TotalDesiredQty
  var labels = order.MailLabelsCount
  if (labels === 0) {
    return 0
  }

  var price1 = 0
  var price2 = 0
  for (var i = 0; i < pricelist.LabelPrices.length; i++) {
    var priceObj = pricelist.LabelPrices[i]
    if (priceObj.PriceName.toLowerCase() === 'shipprice' && priceObj.Lbound <= qty && priceObj.Ubound >= qty) {
      price1 = priceObj.Price1
      price2 = priceObj.Price
      break
    }
  }

  var firstLabelCharge = price1
  var additionalLabelCharge = (labels - 1) * price2
  return firstLabelCharge + additionalLabelCharge
}

// <summary>
// Get Promotion Amount by follow steps:
// 1 find promotion by promotion code
// 2 check whether qty/amount reach the min requirement
// 3 if reach the min requirement, get promo amount by different promotion type
// </summary>
// <param name="order">The order.</param>
// <param name="listPrice">per record price for calculating list price and promotion amount</param>
// <returns></returns>

function GetPromotionCharge (order, promotion) {
  var PCode = order.PromoCode
  var qty = order.TotalDesiredQty
  var singlePrice = order.CostPrice

  order.PromotionPointType = 0
  order.PromotionPointValue = 0

  if (!PCode || (Array.isArray(PCode) && PCode.Length === 0)) {
    return 0
  }

  var totalAmt = order.OrderCharge // singlePrice * qty;

  var promotionAmount = 0
  if (promotion != null) {
    var isPromotionEffective = false
    if (promotion.MinPurAmountType === enums.PromotionMinPurAmtType.BY_TOTAL_SPEND) {
      isPromotionEffective = (totalAmt >= promotion.MinPurAmount)
    } else if (promotion.MinPurAmountType === enums.PromotionMinPurAmtType.BY_TOTAL_RECORDS) {
      isPromotionEffective = (qty >= promotion.MinPurQty)
    } else {
      isPromotionEffective = ((totalAmt >= promotion.MinPurAmount) && (qty >= promotion.MinPurQty))
    }
    if (isPromotionEffective) {
      if (promotion.PromotionType === enums.PromotionType.PERCENT_OFF_TOTAL_PRICE) {
        promotionAmount = totalAmt * promotion.PromotionValue
      } else if (promotion.PromotionType === enums.PromotionType.FLAT_DOLLAR_TOTAL_PRICE) {
        promotionAmount = promotion.PromotionValue
      } else if (promotion.PromotionType === enums.PromotionType.FREE_LEADS) {
        promotionAmount = singlePrice * promotion.PromotionValue
      } else if (promotion.PromotionType === enums.PromotionType.XNUMBER_OF_POINT) {
        order.PromotionPointType = enums.PromotionType.XNUMBER_OF_POINT
        order.PromotionPointValue = promotion.PromotionValue
      } else if (promotion.PromotionType === enums.PromotionType.NUMBER_OF_POINT) {
        order.PromotionPointType = enums.PromotionType.NUMBER_OF_POINT
        order.PromotionPointValue = promotion.PromotionValue
      } else if (promotion.PromotionType === enums.PromotionType.DEBIT_CARD) {
        promotionAmount = promotion.PromotionBalance
      } else if (promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_ONLY || promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_ONLY) {
        if (CheckMobileCondition(order.MobilePackageId, promotion.PackageIds)) {
          CaculateMobilePromotion(order, promotion)
        }
      } else if (promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_LIST_BOTH || promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_LIST_BOTH) {
        if (CheckMobileCondition(order.MobilePackageId, promotion.PackageIds)) {
          if (promotion.PromotionType === enums.PromotionType.DOLLAR_MOBILE_LIST_BOTH) {
            promotionAmount = promotion.PromotionValue
          } else if (promotion.PromotionType === enums.PromotionType.PERCENT_OFF_MOBILE_LIST_BOTH) {
            promotionAmount = totalAmt * promotion.PromotionValue
          }
          CaculateMobilePromotion(order, promotion)
        }
      }
    }
  }

  if (promotionAmount > totalAmt && promotion.PromotionType !== enums.PromotionType.DEBIT_CARD) {
    promotionAmount = totalAmt
  }
  return promotionAmount
}

function CheckMobileCondition (mobilePackageId, packageIds) {
  var isCheck = false
  if (mobilePackageId > 0) {
    var ids = packageIds.split(',')
    for (var i = 0; i < ids.length; i++) {
      if (String(mobilePackageId) === String(ids[i]).trim()) {
        isCheck = true
        break
      }
    }
  }
  return isCheck
}

function GetServiceCharge (order, priceList) {
  return priceList.ServiceCharge
}

function GetGeographyCharge (order, priceList) {
  var geographyCharge = 0
  for (var i = 0; i < priceList.GeographyPrices.length; i++) {
    var price = priceList.GeographyPrices[i]
    if (price.PriceName === order.GeoType.toString()) {
      geographyCharge = price.Price1
      break
    }
  }
  return geographyCharge
}

function SetGeoDetailsDesiredByDetail (orderGeo, value) {
  if (orderGeo === null) return
  var left = value
  if (Array.isArray(orderGeo.OrderGeoDetails) && orderGeo.OrderGeoDetails.length > 0) {
    var geoDetails = orderGeo.OrderGeoDetails
    for (var j = 0; j < geoDetails.length; j++) {
      if (left <= 0) {
        geoDetails[j].DesiredQty = 0
      } else {
        if (geoDetails[j].AvailableQty >= left) {
          geoDetails[j].DesiredQty = left
        } else if (geoDetails[j].AvailableQty > 0) {
          geoDetails[j].DesiredQty = geoDetails[j].AvailableQty
        }
        left = left - geoDetails[j].DesiredQty
      }
    }
  }
}

function SetGeoDetailsDesiredByOrder (order) {
  if (order === null) return null
  if (Array.isArray(order.OrderGeos) && order.OrderGeos.length > 0) {
    for (var i = 0; i < order.OrderGeos.length; i++) {
      SetGeoDetailsDesiredByDetail(order.OrderGeos[i], order.OrderGeos[i].DesiredQty)
    }
  }
}

function CaculatePackage (order, digitalFileQty) {
  if (order === null || order.MobilePackages === undefined || order.MobilePackages === null) return
  if (Array.isArray(order.MobilePackages) && order.MobilePackages.length > 0) {
    for (var i = 0; i < order.MobilePackages.length; i++) {
      if (order.MobilePackages[i].Details != null) {
        for (var j = 0; j < order.MobilePackages[i].Details.length; j++) {
          if (digitalFileQty >= order.MobilePackages[i].Details[j].MinGoal && digitalFileQty <= order.MobilePackages[i].Details[j].MaxGoal) {
            order.MobilePackages[i].ViewCount = order.MobilePackages[i].Details[j].ViewCount
            order.MobilePackages[i].Cost = order.MobilePackages[i].Details[j].Price
            break
          }
        }
      }
    }
  }
}

function PriceElementEquals (priceName, elementName) {
  return String(priceName) === String(elementName)
}

/* eslint-disable no-unused-vars */
function CaculatePrice (order, plUser, plGlobal, promotion, metadataPriceList) {
  if (store.state.order.ListType === 190) { return } // entity.enums.DataSourceType.Mobile_Consumer_Advertising
  order.CostPrice = GetSinglePrice(order, plUser, plGlobal)
  order.GoodsCost = GetSingleGoodsPrice(order, metadataPriceList) * order.TotalDesiredQty
  if (metadataPriceList !== undefined && metadataPriceList != null && order.GoodsCost < metadataPriceList.MapMinPrice) {
    order.GoodsCost = metadataPriceList.MapMinPrice
  }
  // get order charge
  order.OrderCharge = order.CostPrice * order.TotalDesiredQty

  // TODO@PONY need update mulitiCount Price
  // if is MultiCount, re-caculatePrice
  // if (order.OrderGeos.length > 0 && order.OrderGeos[0].GeoType === 24) {
  //   order.OrderCharge = 0

  //   for (let i = 0; i < order.OrderGeos.length; i++) {
  //     order.OrderCharge = order.OrderCharge + order.OrderGeos[i].CostPrice * order.OrderGeos[i].DesiredQty
  //   }

  //   order.CostPrice = order.OrderCharge / order.TotalDesiredQty
  // }

  if (order.OrderCharge < plUser.MinElementsCharge) {
    order.OrderCharge = plUser.MinElementsCharge
  }

  // get shipping charge
  order.ShippingCharge = GetLabelShipCharge(order, plGlobal)
  order.LabelCharge = GetLabelBaseCharge(order, plGlobal)
  order.PromotionAmount = GetPromotionCharge(order, promotion)
  order.ServiceCharge = GetServiceCharge(order, plUser)
  order.GeographyCharge = GetGeographyCharge(order, plUser)

  let cost = null
  if (promotion && promotion.PromotionType === enums.PromotionType.DEBIT_CARD && order.PromotionAmount > 0) {
    var total = order.OrderCharge + order.ShippingCharge + order.LabelCharge + order.ServiceCharge + order.GeographyCharge

    if (total <= plUser.MinElementsCharge) {
      total = plUser.MinElementsCharge
      order.MinElementsChargeApply = true
    }

    if (total > order.PromotionAmount) {
      order.TotalEstmCost = total - order.PromotionAmount
    } else {
      order.PromotionAmount = total
      order.TotalEstmCost = 0
    }
  } else {
    // get sub total charge
    var subTotalCharge = order.OrderCharge - order.PromotionAmount
    if (promotion) {
      if (promotion.IsNoRequired) {
      } else {
        if (order.OrderCharge <= plUser.MinElementsCharge) {
          subTotalCharge = plUser.MinElementsCharge
          order.PromotionAmount = 0
        } else if (order.OrderCharge > plUser.MinElementsCharge) {
          cost = order.OrderCharge - plUser.MinElementsCharge
          if (cost <= order.PromotionAmount) {
            order.OrderCharge = plUser.MinElementsCharge
            subTotalCharge = plUser.MinElementsCharge
            order.PromotionAmount = cost
          } else {
            order.OrderCharge = subTotalCharge
          }
        }
      }
    } else {
      if (subTotalCharge < plUser.MinElementsCharge) {
        subTotalCharge = plUser.MinElementsCharge
      }
    }
    order.SubTotalCharge = subTotalCharge

    order.TotalEstmCost = order.SubTotalCharge + order.ShippingCharge + order.LabelCharge + order.ServiceCharge + order.GeographyCharge
    order.TotalEmailEstmCost = order.CostPrice * order.TotalEmailDesiredQty
    order.RetailCost = order.TotalEstmCost
    order.MinElementsChargeApply = (order.SubTotalCharge === plUser.MinElementsCharge)
    order.MinLabelChargeApply = (order.LabelCharge === plGlobal.MinLabelCharge)
    var orderAmount = order.OrderCharge - order.PromotionAmount + order.ShippingCharge + order.LabelCharge
    order.MinOrderAmountApply = (orderAmount < plUser.MinElementsCharge)
  }

  order.TotalPretaxCost = order.TotalEstmCost
  return order
}

export default {
  updatePrice (order, promotion) {
    order = order || JSON.parse(JSON.stringify(store.state.order))
    promotion = promotion || store.state.summary.Promotion
    // store.state.summary.UserPriceList.MinElementsCharge = 50
    CaculatePrice(order, store.state.summary.UserPriceList, store.state.summary.GlobalPriceList, promotion, store.state.site.BizMetadataPricing)
    return order
  },
  RecaculateTotalGeoQty (order, index) {
    RecaculateTotalGeoQty(order, index)
  },
  RecaculateTotalQty (order) {
    RecaculateTotalQty(order)
  }
}



// WEBPACK FOOTER //
// ./src/assets/priceHelp.js